import React, { ReactElement } from "react";
import TopBarMenu from "./TopBarMenu";
import AlertSimplified from "features/shared/alerts/dtos/AlertSimplified";
import NotificationMenuItem from "./NotificationMenuItem";
import NoContentWrapper from "features/shared/components/noContentWrapper/NoContentWrapper";
import { useTranslation } from "react-i18next";

interface IProps {
  title: string;
  notifications: AlertSimplified[];
  bellRef: React.MutableRefObject<any>;
}

const NotificationsMenu: React.FC<IProps> = (props) => {
  // translations
  const tLabels = useTranslation("shared\\components").t;

  // sub-renders
  const renderMessageItems = (
    items: AlertSimplified[]
  ): Array<ReactElement> => {
    return items.map((item, index) => (
      <NotificationMenuItem alert={item} key={index} bellRef={props.bellRef} />
    ));
  };

  const noContentRender = () => {
    return <div className="p-3 text-muted">{tLabels("notificationsMenu.noContent")}</div>;
  };

  // RENDER
  return (
    <TopBarMenu title={props.title}>
      <NoContentWrapper
        data={props.notifications}
        loadStatus="AfterFirstLoad"
        noContentRender={noContentRender}
      >
        {renderMessageItems(props.notifications)}
      </NoContentWrapper>
    </TopBarMenu>
  );
};

export default NotificationsMenu;
